import type { FaireProductEntity } from "../../entity_types/product";

export const p_46aguvu9vp: FaireProductEntity = {
  token: "p_46aguvu9vp",
  type: "product",
  name: "Ceramic Planter, Coffee Can",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/e195025e0804c7fd6852dbd8aafd4d8c9d6612ffb115810ecce8def886fa6eed.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ff02a642fd849b2abc1ce3d3c3e4f76391330658304da450eadc091a56be93a9.jpeg",
    "https://cdn.faire.com/fastly/c906f7efb0bce752ef737e6cb32fa45d4dd410f0a9d5534e82a85ee603f1c896.jpeg",
    "https://cdn.faire.com/fastly/f0894d82a9539f420b2a14581a74998cff4ccfb674b55945173105a464cdb3cf.jpeg",
    "https://cdn.faire.com/fastly/04ad8ff31453c5b19a3c6b14b600c43946816558c06aeb6c4da27bf65c17c4f7.jpeg",
    "https://cdn.faire.com/fastly/ba9aae57b990e8e7fa21d15ab9bd51a482fa1babff0761ee47f6de047eb285ac.jpeg",
    "https://cdn.faire.com/fastly/1038ed08f4e76f015d013bf76f07a3bc6b06f0e108cca780ed5f18fc227fa75c.jpeg",
    "https://cdn.faire.com/fastly/0d49a3eed6f9c6a202ebe1a1672b3927faa3082f24b1470ddbc0dfbc73eb0eac.jpeg"
  ],
  priceDollars: 14,
  description: "Yeehaw! You’re about to lasso this sweet ceramic planter that looks just like a coffee can. Equal parts quirky and functional, it’s the perfect home for greenery, office supplies, or kitchen utensils. Whether it’s holding a plant or your favorite pens, this little can brings big personality to any space.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n\n• Ceramic planter designed to resemble a classic coffee can\n• Perfect for plants, flowers, utensils, or desk supplies\n• Adds a playful, western-inspired touch to home décor\n• Durable and easy to style in kitchens, offices, or shelves\n• Designed in Bando’s signature bright and whimsical style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫\n\n• Gift shops and home décor boutiques\n• Lifestyle and kitchenware retailers\n• Plant shops and stationery stores\n• Wholesale buyers seeking fun, multifunctional ceramic décor",
  tags: [],
  msrpDollars: 28.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:17.278Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
